import { query_product_out_cancel_record_list } from '@/api/mjstock-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'code',
      label: '出库退货单编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写单据编号',
    },
    {
      type: 'remotemodal',
      name: 's_product_id',
      label: '存货名称',
      disabled: false,
      placeholder: '请选择存货名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-sproduct',
    },
    {
      type: 'remoteselect',
      name: 'order_used_record_id',
      label: '关联耗单',
      disabled: false,
      placeholder: '请选择关联耗单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-orderusedrecord',
    },
    {
      type: 'remoteselect',
      name: 'order_used_cancel_record_id',
      label: '关联耗单退单',
      disabled: false,
      placeholder: '请选择关联耗单退单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-orderusedcancelrecord',
    },
    {
      type: 'remotemodal',
      name: 'product_out_record_id',
      label: '关联出库单',
      disabled: false,
      placeholder: '请选择关联出库单',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstock-productoutrecord',
    },
    {
      type: 'remotemodal',
      name: 'transfer_shop_id',
      label: '调拨去向',
      disabled: false,
      placeholder: '请选择调拨去向',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'input',
      name: 'transfer_code',
      label: '调拨编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写调拨编号',
    },
    {
      type: 'input',
      name: 'transfer_cancel_code',
      label: '调拨退货编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写调拨退货编号',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'remoteselect',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    code: null,
    s_product_id: null,
    order_used_record_id: null,
    order_used_cancel_record_id: null,
    product_out_record_id: null,
    transfer_shop_id: null,
    transfer_code: null,
    transfer_cancel_code: null,
    shop_id: null,
    staff_id: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '出库退货单号',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: '存货编码',
    width: 150,
    dataIndex: 's_product__code',
    fixed: false,
    checked: true,
  },
  {
    title: '存货名称',
    width: 150,
    dataIndex: 's_product__name',
    fixed: false,
    checked: true,
  },
  {
    title: '关联出库单编号',
    width: 150,
    dataIndex: 'product_out_record__code',
    fixed: false,
    checked: true,
  },
  {
    title: '退货日期',
    width: 150,
    dataIndex: 'cancel_datetime',
    fixed: false,
    checked: true,
  },
  {
    title: '退货数量',
    width: 150,
    dataIndex: 'cancel_num',
    fixed: false,
    checked: true,
  },
  {
    title: '退货原因',
    width: 150,
    dataIndex: 'cancel_reason',
    fixed: false,
    checked: true,
  },
  {
    title: '退货单价',
    width: 150,
    dataIndex: 'single_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '退货金额',
    width: 150,
    dataIndex: 'price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '调拨编号',
    width: 150,
    dataIndex: 'transfer_code',
    fixed: false,
    checked: true,
  },
  {
    title: '调拨退货编号',
    width: 150,
    dataIndex: 'transfer_cancel_code',
    fixed: false,
    checked: true,
  },
  {
    title: '调拨去向',
    width: 150,
    dataIndex: 'transfer_shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '执行门店',
    width: 150,
    dataIndex: 'shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '执行人',
    width: 150,
    dataIndex: 'staff__name',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '单据状态',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_product_out_cancel_record_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
